<template>
  <div class="nav-wraper" :class="`nav-wraper--${createRenderType}`">
    <div class="nav-wraper-main height-all">
      <template v-for="(item, index) in getNavs()" :key="item.routername">
        <div
          class="nav-item tl pointer"
          :class="{
            active: item.routername == matchHighLight,
            'nav-item--mobile-hidden': !item.mobileVisible,
          }"
          @click="
            () => {
              goRouter(item);
            }
          "
        >
          <i class="fn-inline high-line"></i>
          <i
            class="fn-inline ico"
            :style="{
              background:
                item.routername == matchHighLight
                  ? `url(${item.highIco})`
                  : `url(${item.ico})`,
              backgroundSize: '100% 100%',
            }"
          ></i>
          <span class="fn-inline text">{{ item.label }}</span>
        </div>
      </template>
    </div>
  </div>
</template>

<script setup>
import {
  defineProps,
  defineEmits,
  computed,
  reactive,
  watch,
  defineExpose,
  onMounted,
  getCurrentInstance,
} from "vue";
import { $$t } from "@/i18n/i18n.js";

import { storeToRefs } from "pinia";
import useCreateLayoutStore from "@/store/create/createLayoutStore.js";
const createLayoutStore = useCreateLayoutStore();
const { createRenderType } = storeToRefs(createLayoutStore);

import { useRouter, useRoute } from "vue-router";

import homeIco from "@/assets/img/home-ico.png";
import homeHighIco from "@/assets/img/home-high-ico.png";

import createIco from "@/assets/img/create-ico.png";
import createHighIco from "@/assets/img/create-high-ico.png";

import storeIco from "@/assets/img/store-ico.png";
import storeHighIco from "@/assets/img/store-high-ico.png";

import APIIco from "@/assets/img/API-ico.png";
import APIHighIco from "@/assets/img/API-high-ico.png";

import creditsIco from "@/assets/img/credits-ico.png";
import creditsHighIco from "@/assets/img/credits-high-ico.png";

import libraryIco from "@/assets/img/library-ico.png";
import libraryHighIco from "@/assets/img/library-high-ico.png";
import useUserDataStore from "@/store/userDataStore.js";

const Router = useRouter();
const route = useRoute();
const userDataStore = useUserDataStore();
const globalProperties =
  getCurrentInstance()?.appContext.config.globalProperties;

const matchHighLight = computed(() => {
  return route?.meta?.title ?? "";
});

// console.log('route',route)
// console.log('Router',Router)

const props = defineProps({});
const emits = defineEmits([]);
const stateData = {};
const getNavs = () => {
  return [
    {
      label: $$t("common.nav_home"),
      routername: "home",
      ico: homeIco,
      highIco: homeHighIco,
      mobileVisible: true,
      code: 0,
    },
    {
      label: $$t("common.nav_create"),
      routername: "create",
      ico: createIco,
      highIco: createHighIco,
      mobileVisible: true,
      code: 1,
    },
    {
      label: $$t("common.nav_store"),
      routername: "store",
      ico: storeIco,
      highIco: storeHighIco,
      mobileVisible: true,
      code: 2,
    },
    {
      label: $$t("common.nav_library"),
      routername: "library",
      ico: libraryIco,
      highIco: libraryHighIco,
      mobileVisible: true,
      code: 3,
    },
    {
      label: $$t("common.nav_credits"),
      routername: "credits",
      ico: creditsIco,
      highIco: creditsHighIco,
      mobileVisible: false,
      code: 4,
    },
  ];
};
const renderData = reactive({
  curnav: "",
});

const gorouter = async (item) => {
  if (item.routername == "library" || item.routername == "credits") {
    if (!(await userDataStore.checkLoginStatus({
      source: item.routername
    }))) {
      return;
    }
  }
  Router.push({ name: item.routername });
};

const goRouter = (item) => {
  renderData.curnav = item.routername;
  gorouter(item);
  globalProperties.logClickEvent("navigation", {
    nav_code: item.code,
  });
};

watch(
  () => route.name,
  (newVal, oldVal) => {
    renderData.curnav = newVal;
  }
);

defineExpose({});
onMounted(() => {
  renderData.curnav = route.name;
});
</script>
<style lang="scss" scope>
.nav-wraper {
  height: 100%;
  padding: 12px 0 0 0;

  .nav-item {
    line-height: 56px;
    margin: 0 0 12px 0;
    i.high-line {
      width: 4px;
      height: 24px;
      opacity: 0;
      background: rgba(148, 173, 255, 1);
    }
    i.ico {
      margin-left: 20px;
      width: 24px;
      height: 24px;
      opacity: 5;
    }
    .text {
      font-family: HarmonyOS Sans SC;
      font-size: 16px;
      font-weight: 400;
      line-height: 24px;
      letter-spacing: 0.04em;
      color: rgba(255, 255, 255, 0.5);
      margin-left: 8px;
    }
  }
  .nav-item:hover {
    .text {
      color: rgba(255, 255, 255, 1);
    }
  }
  .nav-item.active {
    height: 56px;
    i.high-line {
      opacity: 1;
    }
    i.ico {
      opacity: 1;
    }
    .text {
      color: rgba(148, 173, 255, 1);
      font-weight: bold;
    }
  }
  &.nav-wraper--mobile {
    padding: 0 16px;
    position: relative;
    .nav-wraper-main {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      display: flex;
      justify-content: space-between;
    }

    // background: #05102f;
    .nav-item {
      height: 56px;
      line-height: 56px;
      flex: 1;
      text-align: center;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      i.high-line {
        display: none;
      }
      i.ico {
        display: none;
        margin: 0 auto;
        line-height: 20px;
        height: 20px;
        width: 20px;
      }
      .text {
        color: rgba(255, 255, 255, 0.5);
        line-height: 18px;
        margin: 0;
        font-size: 18px;
      }
    }
    .nav-item--mobile-hidden {
      display: none;
    }
    .nav-item:hover {
      .text {
        color: rgba(255, 255, 255, 1);
      }
    }
    .nav-item.active {
      .text {
        color: rgba(148, 173, 255, 1);
        font-weight: bold;
      }
    }
  }
}
</style>
